<template>
  <div class="child-platform overFlowXauto">
    <div class="left-tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="startSearch"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      ></Table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <editForm
        ref="editForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
  </div>
</template>
<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { systemApi } from "../../../../api-path/system-api.js";
export default {
  name: "allUsers",
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      switchVal: false,
      isEdit: false,
      title: "",
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入名称/唯一码",
          },
        ],
      },
      searchParams: {
        areaId: "",
        isDown: "",
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            this.title = "新增";
            this.isEdit = false;
            this.ruleForm = {
              areaId: this.areaId,
              id: "",
              name: "",
              platformKey: "",
              address1: "",
              address2: "",
              address3: "",
              address4: "",
              mediaUrl:"",
              secret:"",
              requestList: "",
            };
            this.dialogVisible = true;
          },
        },
      ],
      dialogVisible: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "TransvrId",
            prop: "id",
          },
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "唯一码",
            prop: "platformKey",
          },
          {
            label: "地址A",
            prop: "address1",
            width: "200px",
            type: "popover",
          },
          {
            label: "地址B",
            prop: "address2",
            width: "200px",
            type: "popover",
          },
        ],
        rowButtons: {
          width: "200px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.ruleForm = data;
                let m = data.requestList.split(",");
                m.map((citem, cindex) => {
                  this.ruleForm["address" + (cindex + 1)] = citem;
                });
                this.title = "编辑";
                this.isEdit = true;
                this.dialogVisible = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("确认删除该条数据?", "删除", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http.get(`${systemApi.platformDel}/${data.id}`).then((res) => {
                      if (res.status === 200) {
                        this.$message({
                          type: "success",
                          message: "操作成功",
                        });
                        this.startSearch();
                      }
                    });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消操作",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页

      //formConfig
      ruleForm: {
        areaId: "",
        id: "",
        name: "",
        platformKey: "",
        address1: "",
        address2: "",
        address3: "",
        address4: "",
        mediaUrl:"",
        secret:"",
        requestList: "",
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入平台名称",
          },
        ],
        platformKey: [
          {
            required: true,
            trigger: "change",
            message: "请输入唯一码",
          },
        ],
        address1: [
          {
            required: true,
            trigger: "change",
            message: "请输入网络地址一",
          },
        ],
      },
      formConfig: {
        disabled: false,
        ref: "rtspform",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "平台名称",
              key: "name", // 数据名称
              prop: "name", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入平台名称", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "唯一码",
              key: "platformKey", // 数据名称
              prop: "platformKey", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入唯一码", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "网络地址一",
              key: "address1", // 数据名称
              prop: "address1", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "请输入网络地址一", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "网络地址二",
              key: "address2", // 数据名称
              prop: "address2", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "请输入网络地址二", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "网络地址三",
              key: "address3", // 数据名称
              prop: "address3", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "请输入网络地址三", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "网络地址四",
              key: "address4", // 数据名称
              prop: "address4", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "请输入网络地址四", // 提示信息
            },
          ],

          [
            {
              valueType: "input", // 类型
              label: "外网地址",
              key: "mediaUrl", // 数据名称
              prop: "mediaUrl", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "新流媒体外网访问地址", // 提示信息
            },
          ],


          [
            {
              valueType: "input", // 类型
              label: "秘钥",
              key: "secret", // 数据名称
              prop: "secret", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "新流媒体秘钥", // 提示信息
            },
          ],

        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              let params = JSON.parse(JSON.stringify(data));
              let info = "";
              if (data.address1 != undefined) {
                info = data.address1;
              }
              if (info.length > 0 && data.address2 != undefined) {
                info = info + "," + data.address2;
              }
              if (info.length > 0 && data.address3 != undefined) {
                info = info + "," + data.address3;
              }
              if (info.length > 0 && data.address4 != undefined) {
                info = info + "," + data.address4;
              }
              params.requestList = info;
              this.$http.post(systemApi.platformSave, params).then((res) => {
                if (res.status == 200) {
                  this.$message.success(this.title + "成功！");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.dialogVisible = false;
            },
          },
        ],
      },
    };
  },
  methods: {
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.ruleForm.areaId = node.id;
      this.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.search = "";
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.startSearch();
    },
    startSearch() {
      this.$http
        .get(systemApi.platformQueryListByPage, { params: this.searchParams })
        .then((res) => {
          if (res.status == 200) {
            let data = res.result.pageList;
            data.map((item) => {
              let m = item.requestList.split(",");
              m.map((citem, cindex) => {
                item["address" + (cindex + 1)] = citem;
              });
            });

            this.tableTemplateData = data;
            this.pagination.total = res.result.total;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.child-platform {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
</style>
